

<body class="mat-app-background">
    <div class="row">
        <div class="col-6">
            <h6 class="d-inline">Datos Actuales: </h6>{{companiaCargada}}
        </div>
        <div class="col-6">

                <h6 class="d-inline">Cargar Datos de: </h6>{{companiaSeleccionada.nombre}}

        </div>
    </div>
    <div class="row">
        <div class="col-6">
            <button class="fw-semibold botones ms-1" >
                Exportar Datos
            </button>
        </div>
        <div class="col-6 d-inline">
            <input type="number" style="width: 60px; border-radius: 15px; text-align: center;" [(ngModel)]="dias">
            <mat-checkbox class="" [(ngModel)]="diasHabiles" [color]="'primary'">
                <label class="fw-semibold gray-color text-center">Dias Habiles</label>
            </mat-checkbox>
            <button class="fw-semibold botones ms-1" (click)="funcionaGanancias()">
                Funcion Ganancias
            </button>
        </div>
    </div>
    <div class="col-panel-wrapper">
      <div class="floating-col-panel" (mouseleave)="contraerColPanel()"
           [ngClass]="{'expanded': colPanelOpen}">
        <div class="col-panel-toggle" (mouseenter)="expandirColPanel()">
          <mat-icon>{{colPanelOpen ? 'chevron_left' : 'view_column'}}</mat-icon>
        </div>
        <div class="col-panel-content">
          <h6 class="col-panel-title mb-2">Columnas</h6>
          <div class="col-panel-option" *ngFor="let column of tableColumns">
            <mat-checkbox [checked]="column.isShow" (change)="toggleColumnVisibility(column.id)" [color]="'primary'">{{column.name}}</mat-checkbox>
          </div>
        </div>
      </div>
    <cdk-virtual-scroll-viewport #earning id="earning" item [appendOnly]="false"
    [tvsItemSize]="24" [headerHeight]="34" class="wrapper mat-elevation-z2 tableStyle">
    <table cdk-table [dataSource]="companiaData" class="table-striped tableStyle">

        <tr cdk-header-row *cdkHeaderRowDef="displayedColumns; sticky: true" class="sticky-header"></tr>
        <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;" (click)="selectRow(row)"
            [ngClass]="{'selected': row === filaSeleccionada}"></tr>
        <ng-container *ngFor="let tablecol of tableColumns">

            <ng-container [cdkColumnDef]="tablecol.id">
                <th cdk-header-cell *cdkHeaderCellDef="" class="sticky-header">
                    {{tablecol.name}}
                </th>
                <td cdk-cell *cdkCellDef="let item" [ngClass]="{'salida': item[tablecol.id] === 'SALIDA',
                                                          'entrada': item[tablecol.id] === 'ENTRADA',
                                                          'numero-positivo': item[tablecol.id] > 0,
                                                          'numero-negativo': item[tablecol.id] < 0
                                                          }">
<!--                     <ng-container *ngIf="tablecol.isString">
                        {{item[tablecol.id]}}
                    </ng-container> -->
                    <ng-container *ngIf="tablecol.isString">
                        <input *ngIf="tablecol.id === 'comentario'" [(ngModel)]="item[tablecol.id]" (blur)="editComentario(item)" class="editable-input"/>
                        <ng-container *ngIf="tablecol.id !== 'comentario'">
                          {{item[tablecol.id]}}
                        </ng-container>
                      </ng-container>
                    <ng-container *ngIf="tablecol.isDate">
                        {{item[tablecol.id] | smartDate }}
                    </ng-container>
                    <ng-container *ngIf="tablecol.isNumber">
                        {{item[tablecol.id] |number:'1.2-2'}}
                    </ng-container>
                </td>
            </ng-container>
        </ng-container>
    </table>
</cdk-virtual-scroll-viewport>
</div>
<div class="spinner-container" *ngIf="loading">
    <mat-spinner diameter="100"></mat-spinner>
  </div>
</body>